<template>
  <div class="wrapper">
    <div class="questionare-text bold big" :class="{'low-opacity': fullfilling}">{{ income ? income.toLocaleString() : 0 }} EUR / m</div>
    <b-spinner v-if="fullfilling" class="align-self-center" variant="primary"></b-spinner>
  </div>
</template>

<script>
export default {
  name: "IncomeDisplayer",
  props: {
    income: Number,
    fullfilling: Boolean
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & .low-opacity {
    opacity: .5;
  }
}
</style>

<style>

</style>